import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { debounceTime, of, Subscription, switchMap, tap } from 'rxjs';
import { DataInput, InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';
import { FormGroup } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NewsService } from 'src/app/services/news.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';


@Component({
	selector: 'rubric-selector',
	templateUrl: './rubric-selector.component.html',
	styles: [ `
		.rubricLine {
			display: flex;
			flex-flow: row nowrap;
			gap: 10px;
			align-items: center;
		}
	` ]
})
export class RubricSelectorComponent implements OnInit, OnDestroy {


	subscriptions = new Subscription();

	formG1 = new FormGroup({});
	myInputs: DataInput[] = [];
	userSuscribable: { [key:string]: boolean } = {};
	@Input() userId = this.authenticationService.getCurrentUser().ebeId;
	@Output() newRubricSelection = new EventEmitter<string[]>();


	constructor(
		private newsService: NewsService,
		private authenticationService: AuthenticationService,
		private matSnackBar: MatSnackBar,
		private matDialog: MatDialog
	) {}


	ngOnInit() {

		this.newsService.getRubrics().pipe(
			switchMap( rubrics => {

				for( const rubric of rubrics ) {
					this.userSuscribable[ rubric.id ] = rubric.userSubscribable;
				}

				const activeRubrics = rubrics
					.filter( r => !!r.active )
					.sort( (a,b) => a.name.localeCompare( b.name ) );


				return ( this.userId
					? this.newsService.getRubricsSubscribedToUser( this.userId )
					: of( [] as string[] )
				).pipe(
					tap( userRubrics => {

						if( !userRubrics ) {
							this.matDialog.open( InfoDialogComponent, {
								data: { title: "Fehler", message: "Beim Abrufen von Rubriken ist ein Fehler aufgetreten" }
							});
							return;
						}

						const bAdmin = this.authenticationService.isAdmin();
						const diValues: { [key: string]: boolean } = {};

						for( const rubric of activeRubrics ) {

							//	if( !bAdmin && !rubric.userSubscribable && !userRubrics.includes(rubric.id) ) continue;

							const di = new DataInput();
							di.id = "" + rubric.id;
							di.type = "check";
							di.label = rubric.name;
							di.disabled = !bAdmin && !rubric.userSubscribable;
							di.defaultValue = userRubrics.includes( rubric.id );
							this.myInputs.push( di );

							diValues[ "" + rubric.id ] = userRubrics.includes( rubric.id );
						}

						setTimeout( () => {

							this.formG1.patchValue( diValues, { emitEvent: false } );

							this.subscriptions.add(

								this.formG1.valueChanges.pipe(
									debounceTime( 400 ),
									switchMap( ( values: { [key:string]: boolean } ) => {

										const rubricIds: string[] = [];
										for( let ctrlName in values ) {
											if( values[ctrlName] ) {
												rubricIds.push( ctrlName );
											}
										}

										// if user is not admin, add manually group ids for which the user is forcibly subscribed
										for( const myInput of this.myInputs ) {
											if( myInput.disabled ) {
												const rubric = rubrics.find( r => r.id == myInput.id );
												if( rubric && !rubric.userSubscribable ) rubricIds.push( rubric.id );
											}
										}

										return this.userId
											? this.newsService.subscribeUserToRubrics( this.userId, rubricIds )
												.pipe(
													tap( b => {
														if( b ) {
															this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );
															if( this.userId == this.authenticationService.getCurrentUser().ebeId ) {
																this.newsService.storeSubscribedRubrics( rubricIds );
															}
														}
														else {
															this.matSnackBar.open( 'Fehlgeschlagene Speicherung', 'Speichern' );
														}
													})
												)
											: of(true).pipe(
												tap( _ => this.newRubricSelection.emit( rubricIds ) )
											);

									})
								).subscribe()
							);

						}, 1 )

					} )
				);

			} )

		).subscribe();

	}

	ngOnDestroy() {

		this.subscriptions.unsubscribe();

	}


}

